import { Routes } from '@angular/router';

import { LanguageGuard, OperationGuard, AuthGuard, LoginGuard, SignupGuard } from '@app/guards';

export const routes: Routes = [
    {
        path: 'operation/unknown',
        loadComponent: () => import('./pages/operation/unknown/unknown.page').then( m => m.OperationUnknownPage),        
        canActivate: [LoginGuard, LanguageGuard]
    },
    {
        path: 'operation/finished',
        loadComponent: () => import('./pages/operation/finished/finished.page').then( m => m.OperationFinishedPage),        
        canActivate: [OperationGuard]
    },
    {
        path: 'login',
        loadComponent: () => import('./pages/login/login.page').then( m => m.LoginPage),        
        canActivate: [OperationGuard, LoginGuard]
    },
    {
        path: 'reset-pwd',
        loadComponent: () => import('./pages/reset-password/reset-password.page').then( m => m.ResetPasswordPage),        
        canActivate: [OperationGuard, LoginGuard]
    },
    {
        path: 'signup',
        loadComponent: () => import('./pages/signup/signup.page').then( m => m.SignupPage),        
        canActivate: [SignupGuard, LoginGuard]
    },
    {
        path: 'sale/post',
        loadComponent: () => import('./pages/sale/post/post.page').then( m => m.SalePostPage),        
        canActivate: [OperationGuard]
    },
    {
        path: 'match/validate',
        loadComponent: () => import('./pages/match/validate/validate.page').then( m => m.MatchValidatePage),        
        canActivate: [OperationGuard]
    },
    {
        path: '',        
        canActivate: [AuthGuard],
        children: [
            {
                path: '',
                redirectTo: 'home',
                pathMatch: 'full',
            },   
            {
                path: 'home',
                loadComponent: () => import('./pages/home/home.page').then((m) => m.HomePage),
            },   
            {
                path: 'missions',
                loadComponent: () => import('./pages/missions/missions.page').then((m) => m.MissionsPage),
            },   
            {
                path: 'community',
                loadComponent: () => import('./pages/community/community.page').then((m) => m.CommunityPage),
            },   
            {
                path: 'settings',
                loadComponent: () => import('./pages/settings/settings.page').then((m) => m.SettingsPage),
            },   
            {
                path: 'shop',
                loadComponent: () => import('./pages/shop/shop.page').then((m) => m.ShopPage),
            },   
            {
                path: 'logout',
                loadComponent: () => import('./pages/logout/logout.page').then( m => m.LogoutPage)
            },   
        ]
    },
    {
        path: '**',
        redirectTo: '',
    }
];
